import React from 'react';
import Product from './product/product';
import { AttraqtSuggestionsProduct } from '../../../../../../../types';
import popularProductsStyles from './popularProducts.module.pcss';

export interface PopularProductsProps {
  popularProducts: AttraqtSuggestionsProduct[];
}

function PopularProducts({ popularProducts }: PopularProductsProps): React.ReactElement {
  return (
    <div className={popularProductsStyles.products}>
      {popularProducts.map((product) => (
        <Product key={product.code} product={product} />
      ))}
    </div>
  );
}

export default PopularProducts;
